"use client";

import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={"light"}
      {...props}
      className="toaster group"
      icons={undefined}
      closeButton
      toastOptions={{
        classNames: {
          error: "group destructive bg-red-500! border-red-500! text-white!",
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-gray-900 group-[.toaster]:border-border group-[.toaster]:shadow-md",
          description: "group-[.toast]:text-gray-500 group-[.destructive]:text-white",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-gray-500",
          closeButton: "group-[.toast]:text-gray-700",
        },
      }}
    />
  );
};

export { Toaster, toast };
